import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  gridOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: 1,
  },
  gridSvg: {
    width: '100%',
    height: '100%',
  },
}));

const GridOverlay = ({
  width = '100%',
  height = '100%',
  spacing = 24,
  color = '#0000004d',
  opacity = 0.3,
  strokeWidth = 0.5,
  className = ''
}) => {
  const classes = useStyles();

  return (
    <div
      className={`${classes.gridOverlay} ${className}`}
      style={{
        width,
        height,
        backgroundImage: `
          linear-gradient(to right, ${color} ${strokeWidth}px, transparent ${strokeWidth}px),
          linear-gradient(to bottom, ${color} ${strokeWidth}px, transparent ${strokeWidth}px)
        `,
        backgroundSize: `${spacing}px ${spacing}px`,
        opacity: opacity
      }}
    />
  );
};

export default GridOverlay;
